import React from 'react';

import studies from './studies.json';

const createDescription = description => ({
  __html: description,
})

export const Studies = () => (
  <section className="o-section  t-section  ">

    <div className="o-section__header-bg  t-section__header"></div>
    <div className="o-section__content-bg  t-section__content"></div>

    <div className="o-container">
      <div className="o-section__container">

        <header className="o-section__header  t-section__header">
          <div className="o-content">
            <h2 className="o-section__heading">Education</h2>
          </div>
        </header>

        <div className="o-section__content  t-section__content  u-pt-0">

          <div className="o-content">
            <div className="a-education-timeline  c-timeline  t-border-color  o-section__full-top-space">
              <div className="c-timeline__end  t-border-color"></div>
              { studies.map(study => (
                <div className="c-timeline__item" key={study.period}>
                  <div className="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                  <div className="o-content">
                    <div className="o-grid">
                      <div className="o-grid__col-md-5">
                        <div className="c-work__timeframe">{study.period}</div>
                        <h3 className="c-work__heading">
                          {!!study.school.url && (
                            <a href={study.school.url} target="_blank" rel="noopener noreferrer" name={`External link to ${study.school.name}`}>{study.school.name}</a>
                          )}
                          {!study.school.url && study.school.name}
                        </h3>
                        <h4 className="c-work__title">{study.title}</h4>
                        <div className="c-work__location">{study.location}</div>
                      </div>
                      <div className="o-grid__col-md-7" dangerouslySetInnerHTML={createDescription(study.description)} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>

      </div>
    </div>

  </section>
);



// WEBPACK FOOTER //
// ./src/components/Studies/Studies.js